import { render, staticRenderFns } from "./notorder.vue?vue&type=template&id=1271a5b5&scoped=true&"
import script from "./notorder.vue?vue&type=script&lang=js&"
export * from "./notorder.vue?vue&type=script&lang=js&"
import style0 from "./notorder.vue?vue&type=style&index=0&id=1271a5b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../55/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1271a5b5",
  null
  
)

export default component.exports